import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './NoPageFound.css';
import Service from '../service/Service';
const service = new Service();

class NoPageFound extends Component {
  render() {
    return (
      <div className="main-container">
        <Helmet
          title="Page not found - FirstCry Parenting"
        />
        <div className="error-container">
          <div>Ooops... Error 404</div>
          <div>Sorry, but the page you are looking for doesn't exist.</div>
          <div>You can go to the <Link to={service.getRedirectUrl("/")}>HOMEPAGE</Link></div>
        </div>
      </div>
    );
  }
}

export default NoPageFound;